export const dictionary = {
    common: {
        ui: {
            menu: {
                main: {
                    sections: {
                        sensors: "Sensores",
                        observations: "Observações",
                        modelling: "Modelação",
                        mapFeatures: "Recursos do mapa",
                        output: "Exportar & Reportar",
                        setUp: "Configuração",
                    },
                },
            },
        },
    },
    temporalUnits: {
        millis: { long: { singular: 'milissegundo', plural: 'milissegundos' }, short: { singular: 'ms', plural: 'ms' } },
        seconds: { long: { singular: 'segundo', plural: 'segundos' }, short: { singular: 'seg.', plural: 'seg.' } },
        minutes: { long: { singular: 'minuto', plural: 'minutos' }, short: { singular: 'min.', plural: 'min.' } },
        hours: { long: { singular: 'hora', plural: 'horas' }, short: { singular: 'h', plural: 'hrs.' } },
        days: { long: { singular: 'dia', plural: 'dias' }, short: { singular: 'dia', plural: 'dias' } },
        weeks: { long: { singular: 'semana', plural: 'semanas' }, short: { singular: 'sem.', plural: 'sems.' } },
        months: { long: { singular: 'mês', plural: 'meses' }, short: { singular: 'mês', plural: 'meses' } },
        quarters: { long: { singular: 'trimestre', plural: 'trimestres' }, short: { singular: 'tri.', plural: 'tris.' } },
        years: { long: { singular: 'ano', plural: 'anos' }, short: { singular: 'ano', plural: 'anos' } },
    },
    timezone: "Fuso horário",
    custom: 'alterado',
    period: 'período',
};
